'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { ChevronRight } from 'lucide-react'

const SIGNUP_URL = '/auth/login'

export function FixedBottomBar() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handle = () => setVisible(window.scrollY > window.innerHeight * 0.8)
    window.addEventListener('scroll', handle, { passive: true })
    return () => window.removeEventListener('scroll', handle)
  }, [])

  return (
    <div
      aria-label="Barra de ação"
      style={{
        position: 'fixed',
        bottom: 16,
        left: '50%',
        transform: `translateX(-50%) translateY(${visible ? '0' : '100px'})`,
        opacity: visible ? 1 : 0,
        transition: 'transform 0.4s ease, opacity 0.4s ease',
        width: 'calc(100% - 32px)',
        maxWidth: 464,
        zIndex: 200,
      }}
    >
      <div
        style={{
          background: 'rgba(255,255,255,0.90)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          border: '1px solid rgba(255,255,255,0.65)',
          borderRadius: 24,
          padding: '8px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12), 0 1px 0 rgba(255,255,255,0.95) inset',
        }}
      >
        <Link
          href={SIGNUP_URL}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            height: 52,
            background: '#1A5C2E',
            color: '#fff',
            borderRadius: 16,
            fontWeight: 700,
            fontSize: 15,
            fontFamily: 'var(--font-jakarta)',
            textDecoration: 'none',
            boxShadow: '0 4px 14px rgba(26,92,46,0.32)',
          }}
        >
          Começar grátis <ChevronRight size={16} strokeWidth={2.5} />
        </Link>
      </div>
    </div>
  )
}
